import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import * as TYPES from "./actionTypes";
import * as ACTIONS from "./actions";
import * as USER_ACTIONS from "../login/actions";

import * as API from "helpers/backend_helper";

import {errorMsg, successMsg} from "helpers/toastr";

 /**
      * Used for calling auth user api
      */

function* verifyEmail({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postVerifyEmail, user);

    callback && callback(response);
    if (response.status == "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.verifyEmailFailed(response.message));
    }
    yield put(ACTIONS.verifyEmailSuccessful(response));
  } catch (error) {
    errorMsg(error?.response?.data?.message)
    yield put(ACTIONS.verifyEmailFailed("Internal Server Error"));
  }
}

function* onResetPassword({ payload: { user, callback } }) {
  try {
    const response = yield call(API.postResetPassword, user);

    callback && callback(response);
    if (response.status == "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.resetPasswordFailed(response.message));
    }

    yield put(ACTIONS.resetPasswordSuccessful(response));
  } catch (error) {
    errorMsg(error?.response?.data?.message)
    yield put(ACTIONS.resetPasswordFailed("Internal Server Error"));
  }
}

export function* watchVerifyEmail() {
  yield takeEvery(TYPES.VERIFY_EMAIL, verifyEmail);
  yield takeEvery(TYPES.RESET_PASSWORD, onResetPassword);

}

function* verifySaga() {
  yield all([fork(watchVerifyEmail)]);
}

export default verifySaga;
